import { Link, Typography } from "@mui/material";
import { Links, SystemStatus } from "src/constants";
import { FeedItemDto, FeedItemRoleAccountabilityValueDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const RoleAccountabilityPropertyChange = (props: Props) => {
  const value = props.feedItem.propertyChange!.value as FeedItemRoleAccountabilityValueDto;

  if (props.feedItem.propertyChange?.changeType === SystemStatus.Created) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> added accountability </span>
        <strong>{value.newDescription}</strong>
      </Typography>
    );
  }

  if (props.feedItem.propertyChange?.changeType === SystemStatus.Deleted) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed accountability </span>
        <strong>{value.newDescription}</strong>
      </Typography>
    );
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated accountability from </span>
      <strong>{value.oldDescription}</strong>
      <span> to </span>
      <strong>{value.newDescription}</strong>
    </Typography>
  );
};

export { RoleAccountabilityPropertyChange };
